/**
 * 互动游戏上麦逻辑
 * */

import WEBROOM from '../../../../../store/WebRoom';
import Util from '../../../../../script/util';
import { message, Modal } from 'antd';
import HTTP from '../../../../../script/service';

// 阵营枚举
export const CAMP_ENUM = { 1: '红方', 2: '蓝方' };

/**
 * 返回是否可以上麦
 * @param index 上麦位置
 * @param account 用户账号
 * @param isMaster 是否是主播
 * @returns {boolean} 是否可以上麦
 * */
export const isUpMic = async (index, account, isMaster = false) => {
  /**
   * rmode 4 互动游戏模板
   * pkStatus 1 正在PK中
   * psStatus 3 正在启动中
   * */
  if (
    WEBROOM?.roomInfo?.custom?.rmode === 4 &&
    (WEBROOM?.gameInteractData?.pkStatus === 1 ||
      WEBROOM?.gameInteractData?.pkStatus === 3)
  ) {
    const { playType, blueTeams, redTeams } = WEBROOM?.gameInteractData;
    const uid = Util.$analyToUid(account);
    let camp = await getMyCamp(uid);
    const campid = camp?.[0] || null;
    if (playType === 2) {
      // 跨房PK
      const roomCamp = getRoomCamp();
      if (campid && campid !== roomCamp) {
        let text = `您已加入对方的阵营，本局游戏中无法上到此麦位哦~`;
        if (isMaster) {
          if (roomCamp === 1) {
            text = `TA已加入蓝方阵营，本局游戏中无法上到此麦位哦~`;
          } else if (roomCamp === 2) {
            text = `TA已加入红色阵营，本局游戏中无法上到此麦位哦~`;
          }
        }
        Modal.info({
          title: '提示',
          icon: null,
          closable: true,
          centered: true,
          className: 'daidai-confirm-style font-size-16',
          content: text,
          okText: '我知道了',
        });
        return false;
      }
    } else if (playType === 1) {
      // 本房间
      if (index >= 0 && index < 4) {
        if (campid === 2) {
          let text = '您已加入蓝方阵营，本局游戏中无法上到此麦位哦~';
          if (isMaster) {
            text = 'TA已加入蓝方阵营，本局游戏中无法上到此麦位哦~';
          }
          Modal.info({
            title: '提示',
            icon: null,
            closable: true,
            centered: true,
            className: 'daidai-confirm-style font-size-16',
            content: text,
            okText: '我知道了',
          });
          return false;
        } else if (campid !== 1) {
          if (redTeams?.length > 20) {
            message.warning('');
            Modal.info({
              title: '提示',
              icon: null,
              closable: true,
              centered: true,
              className: 'daidai-confirm-style font-size-16',
              content: '红方阵营人数已满',
              okText: '我知道了',
            });
            return false;
          }
        }
      } else if (index >= 4 && index < 8) {
        if (campid === 1) {
          let text = '您已加入红方阵营，本局游戏中无法上到此麦位哦~';
          if (isMaster) {
            text = 'TA已加入红方阵营，本局游戏中无法上到此麦位哦~';
          }
          Modal.info({
            title: '提示',
            icon: null,
            closable: true,
            centered: true,
            className: 'daidai-confirm-style font-size-16',
            content: text,
            okText: '我知道了',
          });
          return false;
        } else if (campid !== 2) {
          if (blueTeams?.length > 20) {
            Modal.info({
              title: '提示',
              icon: null,
              closable: true,
              centered: true,
              className: 'daidai-confirm-style font-size-16',
              content: '蓝方阵营人数已满',
              okText: '我知道了',
            });
            return false;
          }
        }
      }
    }
  }

  return true;
};

// 同步用户加入阵营情况 todo 需要调整
const syncUserCamp = (data) => {
  // campid 1: 红色阵营 2：蓝色阵营
  if (
    WEBROOM?.gameInteractData?.pkStatus === 1 ||
    WEBROOM?.gameInteractData?.pkStatus === 3
  ) {
    setGameInteractCamp(data.uid, data.campid);
    WEBROOM.events['UPDATE_GAME_INTERACT_DATA'] &&
      WEBROOM.events['UPDATE_GAME_INTERACT_DATA']();
  }
};

/**
 * 返回队列中的用户阵营
 * @param uid 用户uid
 * */
export const getUserCamp = (uid) => {
  return getGameInteractCamp(uid);
};

/**
 * 返回房间的阵营
 * @param roomid 房间id // null 当前房间阵营
 * */
export const getRoomCamp = (roomid) => {
  const { roomid: curRoomId, gameInteractData } = WEBROOM;
  if (gameInteractData && gameInteractData.pkStatus !== -1) {
    if (roomid) {
      roomid = roomid.toString();
    } else {
      roomid = curRoomId;
    }
    let team = null;
    if (gameInteractData?.redTeams?.length) {
      team = gameInteractData.redTeams.find((item) => item.roomId === roomid)
        ? 1
        : null;
    }
    if (!team && gameInteractData?.blueTeams?.length) {
      team = gameInteractData.blueTeams.find((item) => item.roomId === roomid)
        ? 2
        : null;
    }
    return team;
  }
  return 0;
};

// 设置加入阵营的用户，包含通过消息加入阵营的用户
export const setGameInteractCamp = (uid, campid, isSync = false) => {
  if (!window.gameInteractCamp) window.gameInteractCamp = new Map();
  if (isSync) {
    syncUserCamp({ uid, campid });
  }
  window.gameInteractCamp.set(uid.toString(), campid);
};
// 返回加入阵营的用户，包含通过消息加入阵营的用户
export const getGameInteractCamp = (uid) => {
  if (!window.gameInteractCamp) return null;
  if (!uid) {
    uid = WEBROOM.uid;
  }
  let campid = null;
  if (window.gameInteractCamp?.get) {
    const camp = window.gameInteractCamp.get(uid.toString());
    campid = camp == null ? null : Number(camp) || 0;
  }
  return campid;
};

/**
 * 查询我加入阵营
 * @param uids {Array | String | Number} 用户uid
 * @returns {Promise<number>} 0 无阵营 1 红色阵营 2 蓝色阵营
 * */
export const getMyCamp = (uids) => {
  return new Promise((resolve) => {
    const camps = [];
    if (
      WEBROOM?.gameInteractData?.pkStatus === 1 ||
      WEBROOM?.gameInteractData?.pkStatus === 3
    ) {
      const queryUsers = [];
      if (!uids) {
        // 当查询用户为空时，默认查询自己
        queryUsers.push({ queryUid: WEBROOM.uid });
      } else if (Array.isArray(uids) && uids?.length) {
        uids.forEach((uid) => queryUsers.push({ queryUid: uid }));
      } else {
        queryUsers.push({ queryUid: uids });
      }

      const len = queryUsers.length;
      if (len) {
        const notCamps = []; // 没有阵营的用户
        queryUsers.forEach((n) => {
          const campid = getGameInteractCamp(n.queryUid);
          if (campid == null) {
            notCamps.push(n);
          } else {
            camps.push(campid);
          }
        });
        if (notCamps?.length) {
          const params = {
            content: JSON.stringify({
              currentRoomId: WEBROOM?.roomid,
              gamePlayId: WEBROOM.gameInteractData?.gamePlayId || null,
              items: notCamps,
            }),
          };
          HTTP._get_interactive_user_camp(params)
            .then((res) => {
              if (res?.code === 200) {
                const data = res?.data?.items || [];
                if (data?.length) {
                  data.forEach((n) => {
                    camps.push(n?.campid ?? null);
                    const isSync = WEBROOM?.uid == n.finalUid;
                    setGameInteractCamp(n.finalUid, n.campid ?? 0, isSync);
                  });
                }
              }
            })
            .finally(() => {
              resolve(camps);
            });
        } else {
          resolve(camps);
        }
      } else {
        resolve(camps);
      }
    } else {
      resolve(camps);
    }
  });
};

export const avatarWithSize = (url, size) => {
  if (url?.includes('https://')) {
    return `${url}/${size}`;
  }
  return Util.transImgUrl(url, size);
};
